export default {
  data() {
    return {
      currencies: {
        EUR: '€',
        GBP: '£',
        PLN: 'zł',
        DKK: 'Kr.',
        CHF: 'Fr.',
        HUF: 'Ft.',
        CZK: 'Kč',
      },
    };
  },
  methods: {
    formatCurrency(currency) {
      if (this.currencies[currency]) {
        return this.currencies[currency];
      }
      return currency;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/currencies.js